const list = {
  components() {
    return [
      {
        component: "search-select-field",
        label: "사업장명",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      // {'component': 'empty-space'},
      // {
      //   'component': 'search-select-company-tree', label: '부서명', value: 'companyTree', query: {'c0': 'company0', 'c1': 'company1', 'c2': 'company2'}, options: {
      //     default: { company0: null, company1: null, company2: null },
      //   }
      // },
      {
        component: "search-select-company-name",
        label: "부서명",
        value: "companyName",
        query: { cName: "companyName" },
        options: {
          default: "",
          targetKey: "body.targetCompany",
        },
      },
      {
        component: "search-keyword",
        label: "성명",
        value: "fn",
        query: { fn: "fn" },
        options: {
          default: "",
        },
      },
      // {'component': 'empty-space'},
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: {
          hiddenList: ["부서명", "사업장명", "성별", "성명", "최종 입사일", "총 교육이수 시간"],
        },
      },
      {
        component: "search-employee-type",
        label: "계약상태",
        value: "employeeState",
        query: { eps: "employeeState" },
        options: { default: "activated" },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    if (search.field.fieldId) {
      conditions.push({ key: "body.fieldNames[%]", operator: "=", value: `${search.field.fieldName}` });
    }

    console.log("search", search);
    if (search.fn) {
      conditions.push({ key: "full_name", operator: "=", value: `${search.fn}` });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }

    // 계약 상태를 적용한다
    // now = 현재 날짜 (YYYY-MM-DD)
    const now = new Date().toISOString().split("T")[0];
    switch (search.employeeState) {
      case "activated":
        conditions.push({ key: "body.retirement_date", operator: ">n", value: now });
        break;
      case "retired":
        conditions.push({ key: "body.retirement_date", operator: ">", value: "1900-01-01" });
        conditions.push({ key: "body.retirement_date", operator: "<=", value: now });
        break;
      default:
        break;
    }

    return conditions;
  },

  getHead: () => {
    return [
      {
        name: "부서명",
        key: "field.com_name",
        sortKey: false,
      },
      {
        name: "팀명",
        key: "field.team_company_list[%].com_name",
        sortKey: false,
      },
      { name: "사업장명", key: "body.stdInfo.field_name" },
      { name: "구분", key: "body.job_category" },
      // conditions 의 key 값이 full_name 인 경우 fullname 파라미터로 변경 (433 에서만 검색됨)
      { name: "성명", key: "full_name" },
      { name: "총 교육이수 시간", key: "", sortKey: false },
      { name: "입사일", key: "body.hire_date" },
      { name: "퇴임일", key: "body.retirement_date" },
      { name: "직종", key: "body.employment_type" },
      { name: "성별", key: "body.gender" },
      { name: "연락처", key: "enc.contact_number" },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: {
          // 부서명
          const meta = JSON.parse(value.field.meta || "{}");
          return func.getContent(value).stdInfo.부서명_과 || meta.com_name; // 부서명_과
        }
        case 1: {
          const team_company_list = JSON.parse(value.field.meta || "{}").team_company_list;
          return team_company_list ? team_company_list.map((team) => team.com_name).join(", ") : "-";
        }
        case 2: {
          // 사업장명
          const fieldNames = !func.getContent(value).fieldNames ? func.getContent(value).field_names : func.getContent(value).fieldNames;
          if (fieldNames && fieldNames.length === 1) {
            return fieldNames.join(", ");
          } else if (fieldNames && fieldNames.length > 1) {
            // 만약 두번째 아이템이 4글자 이하면 첫번째와 두번째 아이템을 쉼표로 붙여서 반환한다
            if (fieldNames[1].length <= 4) {
              return `${fieldNames[0]}, ${fieldNames[1]}`;
            } else {
              return `${fieldNames[0]}, ${fieldNames[1].substring(0, 4)}...`;
            }
          } else {
            return "-";
          }
        }
        case 3:
          return func.getContent(value).job_category; // 구분
        case 4:
          return func.getContent(value).enc.full_name; // 성명
        case 5: {
          // 총 교육이수 시간
          if (typeof value.total_education_hours === "undefined") return "0시간 0분";
          const totalEducationHours = value.total_education_hours;

          // "H시간 M분" 형식으로 변환한다.
          // 데이터는 3.5 와 같은 형식으로 저장되어 있으며 "3시간 30분" 으로 변환되야 한다.
          const hours = Math.floor(totalEducationHours);
          const minutes = Math.round((totalEducationHours - hours) * 60);
          return `${hours}시간 ${minutes}분`;
        }
        case 6:
          return func.getContent(value).hire_date; // 최종 입사일
        case 7:
          return func.getContent(value).retirement_date; // 퇴임일
        case 8:
          return func.getContent(value).employment_type; // 직종
        case 9:
          return func.getContent(value).enc.gender ? func.getContent(value).enc.gender : func.getContent(value).gender; // 성별
        case 10:
          return func.getContent(value).enc.contact_number; // 연락처
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},

  excelInfo: (list) => {
    return {
      filePath: "/employees/종사자_업로드_템플릿.xlsx",
      downloadFileName: "종사자 정보(현황)",
      worksheetName: (data) => {
        return "종사자 정보(현황)";
      },
      singleSheet: (worksheet, list) => {
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          const body = JSON.parse(item.post_content).body;
          let fieldNames = [];
          if (body.fieldNames) {
            fieldNames = [...body.fieldNames];
          } else if (body.field_names) {
            fieldNames = [...body.field_names];
          }

          let 부서명_과 = "";
          if (item.field) {
            const meta = JSON.parse(item.field.meta || "{}");
            부서명_과 = body.stdInfo.부서명_과 || meta.com_name; // 부서명_과
          }

          // 총 교육이수 시간
          console.log("item", item);
          const totalEducationHours = typeof item.total_education_hours === "undefined" ? "0시간 0분" : item.total_education_hours;
          console.log("totalEducationHours", totalEducationHours);

          // "H시간 M분" 형식으로 변환한다.
          // 데이터는 3.5 와 같은 형식으로 저장되어 있으며 "3시간 30분" 으로 변환되야 한다.
          const hours = Math.floor(totalEducationHours);
          const minutes = Math.round((totalEducationHours - hours) * 60);
          const 총교육이수시간 = `${hours}시간 ${minutes}분`;

          worksheet.addRow([
            i + 1, //no
            부서명_과, // 부서명
            body.targetCompany, //팀명
            fieldNames.join(", "), //사업장명
            body.job_category, // 구분
            body.enc.full_name, //성명
            총교육이수시간, //총 교육이수 시간
            body.hire_date, //입사일
            body.retirement_date, //퇴임일
            body.employment_type, //직종
            body.enc.gender || body.gender, //성별
            body.enc.contact_number, //핸드폰
          ]);
        }
      },
    };
  },
};
export default list;
